function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Vogel_Druck",
  transform: "translate(-68.047 -250.938)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_134",
  "data-name": "Rechteck 134",
  width: 121.39,
  height: 6.813,
  transform: "translate(68.047 250.938)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_135",
  "data-name": "Rechteck 135",
  width: 121.39,
  height: 6.813,
  transform: "translate(68.047 325.567)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_327",
  "data-name": "Pfad 327",
  d: "M99.795,263.4H91.423l-7.168,28.045H83.5L76.384,263.4H68.151l10.011,35.767H89.784Z",
  transform: "translate(0.089 10.689)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_328",
  "data-name": "Pfad 328",
  d: "M108.693,276.248c-.156-1.392-1.423-8-11.453-7.936h-.019c-10.03-.059-11.3,6.544-11.453,7.936h-.024V287.4h.02c.136,1.3,1.325,8.034,11.457,7.973h.019c11.206.067,11.477-8.207,11.477-8.207V276.248Zm-7.61,10.414h-.067c0,2.5-3.727,2.477-3.785,2.477s-3.785.02-3.785-2.477h-.019v-9.639h.019c0-2.5,3.727-2.477,3.785-2.477s3.785-.02,3.785,2.477h.067Z",
  transform: "translate(15.185 14.907)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_329",
  "data-name": "Pfad 329",
  d: "M123.479,268.816l-7.789-.037a19.207,19.207,0,0,0-4.541-.466h-.019c-9.3-.045-10.479,4.812-10.624,5.836h-.022v8.2h.019c.124.953,1.23,5.907,10.628,5.862h.019c10.4.05,10.646-6.035,10.646-6.035v-8.027h-.022a4.876,4.876,0,0,0-.282-1.031l1.988-1.011Zm-8.768,11.527c0,1.836-3.519,2.061-3.571,2.061s-3.51-.225-3.51-2.061h-.019v-4.21h.019c0-1.836,3.525-1.9,3.579-1.9s3.5.061,3.5,1.9v4.21Z",
  transform: "translate(27.832 14.907)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_330",
  "data-name": "Pfad 330",
  d: "M103.942,278.1l-1.433,1.665s-2.689,4.05-.039,6.271a7.444,7.444,0,0,0,4.026,1.472l4.567.464s4.723.543,4.723,1.9-1.122,1.858-4.065,1.858a63.019,63.019,0,0,1-10.141-1.161l-1.2,5.961s8.129.968,11.767.968,9.407-.543,10.373-5.3V287.2s-.582-4.22-6.464-4.181l-5.574-.543s-2.633-.968.425-2.709",
  transform: "translate(27.743 23.309)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_331",
  "data-name": "Pfad 331",
  d: "M136.44,276.165c-.147-1.392-1.343-8-10.814-7.936h-.019c-9.472-.059-10.667,6.544-10.814,7.936h-.024v.775l-.087,1.743v5.961l-.009,1.126a11.125,11.125,0,0,0,1.936,6.193c6.425,7.046,19.663,1.819,19.663,1.819l-1.239-5.923a50.433,50.433,0,0,1-9.522,1.354c-3.473,0-3.352-3.681-3.272-4.567h14.112v-5.961l.115-1.743v-.777Zm-7.25,2.516h-7.148v-1.743c0-2.5,3.521-2.477,3.573-2.477s3.573-.02,3.573,2.477v1.743Z",
  transform: "translate(40.006 14.836)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_332",
  "data-name": "Pfad 332",
  d: "M137.039,300.522H129.3V263.207l7.742-1.124Z",
  transform: "translate(52.554 9.563)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_333",
  "data-name": "Pfad 333",
  d: "M169.617,274.647c.128-2.252.091-11.626-9.465-11.626h-16.9v36.464h16.9c.58,0,3.107-.522,6.416-2.817s3.049-8.564,3.049-8.564V274.647Zm-9.465,16.912h-8.536V270.945h7.007s2.633.163,2.633,3.454v13.7C161.255,291.588,160.152,291.558,160.152,291.558Z",
  transform: "translate(64.53 10.368)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_334",
  "data-name": "Pfad 334",
  d: "M175.461,275.525l-.58-7.317a22.806,22.806,0,0,0-6.758,3.107l-.056-2.8-7.354-.039v27.1h7.9l-.321-16.057C170.614,277.182,175.461,275.525,175.461,275.525Z",
  transform: "translate(79.511 14.818)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_335",
  "data-name": "Pfad 335",
  d: "M194.122,284.669V268.334h-8.246v17.551a39.052,39.052,0,0,1-4.006,1.9c-3.194,1.336-3.077-1.336-3.077-1.336V268.332h-8.246v18.116a10.925,10.925,0,0,0,0,1.626,11.925,11.925,0,0,0,1.743,5.574c1.336,2.09,7.49,1.626,7.49,1.626l7.272-2.425.857,2.347h6.271V284.666h-.058Z",
  transform: "translate(87.926 14.925)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_136",
  "data-name": "Rechteck 136",
  width: 7.897,
  height: 9.755,
  transform: "translate(287.14 292.279)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_336",
  "data-name": "Pfad 336",
  d: "M193.861,278.438s.193,2.129,4.084,1.722,5.342-.58,5.342-.58l.987,6.388s-10.8,2.438-15.329-1.509c0,0-2.884-3.213-2.98-6.02h7.9Z",
  transform: "translate(101.176 23.596)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_337",
  "data-name": "Pfad 337",
  d: "M204.331,269.035l-.987,6.154s-6.154-1.044-7.694-.087a3.857,3.857,0,0,0-1.789,2.371l-1.9,2.3-6-2.3s.223-8.9,7.77-9.193C193.734,268.28,201.254,267.816,204.331,269.035Z",
  transform: "translate(101.176 14.805)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_80",
  "data-name": "Gruppe 80",
  transform: "translate(310.519 271.841)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_338",
  "data-name": "Pfad 338",
  d: "M198.547,300.586h7.9v-38.4l-7.9,1.237Z",
  transform: "translate(-198.547 -262.188)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_339",
  "data-name": "Pfad 339",
  d: "M211.445,281.527l6.5-13.006h-8.023l-6.561,13.006L210.448,295h8.12Z",
  transform: "translate(-194.413 -256.754)"
})));

var SvgVogeldruck = function SvgVogeldruck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266.627,
    height: 81.442,
    viewBox: "0 0 266.627 81.442",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVogeldruck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vogeldruck.8d99bc7f.svg";
export { ForwardRef as ReactComponent };